/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { BrowserSupportService as o } from "./browser-support.service.mjs";
import { canUseDOM as t } from "./canUseDOM.mjs";
const s = () => !t || !document.body ? !1 : new o().scrollbarWidth, d = (r) => {
  if (!t || !document.body)
    return !1;
  const e = r || new o().scrollbarWidth;
  document.body.style.setProperty("--kendo-scrollbar-width", `${e}px`);
};
export {
  s as getScrollbarWidth,
  d as setScrollbarWidth
};
